import { G_elements } from "./globals/elements";

/**
 *
 * @param {String} type
 * @param {Map<TorusElement, MainClassProps> | null | undefined} [targets]
 * @returns {Map<MainClassProps, Array<String>>}
 */
const getLocalTrigger = (type, targets) => {
  const map = new Map();
  const elements = targets?.size ? targets : G_elements;

  for (const values of elements.values()) {
    const main = /** @type {MainClassProps} */ (values);
    const triggers = main.triggers?.get(type);

    if (triggers) {
      map.set(main, triggers);
    }
  }

  return map;
};

export default getLocalTrigger;
